import {Locales} from '@netx/core-next/locales/utils/Locales';
import {DateType, DateSubType} from './constants';

export const DateRuleTypeLabel: Record<DateType, string> = Locales((i18n) => ({
	[DateType.CREATION_DATE]: i18n('i18n.creationDate'),
	[DateType.IMPORT_DATE]: i18n('i18n.importDate'),
	[DateType.LAST_MODIFIED]: i18n('i18n.lastModified'),
	[DateType.USER_DEFINED_ATTRIBUTE]: i18n('i18n.userDefinedAttribute'),
	[DateType.EXPIRATION_DATE]: i18n('i18n.expirationDate'),
}));

export const DateRuleSubTypeLabel: Record<DateSubType, string> = Locales(
	(i18n) => ({
		[DateSubType.AFTER]: i18n('i18n.after'),
		[DateSubType.BEFORE]: i18n('i18n.before'),
		[DateSubType.IN_BETWEEN]: i18n('i18n.inBetween'),
		[DateSubType.LAST_MONTH]: i18n('i18n.pastMonth'),
		[DateSubType.LAST_SIX_MONTHS]: i18n('i18n.past6Months'),
		[DateSubType.LAST_THREE_MONTHS]: i18n('i18n.past3Months'),
		[DateSubType.LAST_WEEK]: i18n('i18n.pastWeek'),
		[DateSubType.LAST_YEAR]: i18n('i18n.pastYear'),
		[DateSubType.TODAY]: i18n('i18n.today'),
		[DateSubType.YESTERDAY]: i18n('i18n.yesterday'),
	}),
);
